import { useEffect, useState } from 'react'

import { getLeadNotes } from '../api'
import { toast } from '@sales-center/components'
import { useAppDispatch } from '@user/store/hooks/useAppDispatch'

interface Props {
  leadId: number
  take: number
}

export const useGetLeadNotesOnMount = (props: Props) => {
  const dispatch = useAppDispatch()
  const { leadId, take } = props

  const [status, setStatus] = useState<'pending' | 'success' | 'fail'>(
    'pending',
  )

  useEffect(() => {
    let mounted = true

    const execute = async () => {
      try {
        const result = await dispatch(
          getLeadNotes({ leadId, includeExternal: true, query: { take } }),
        )

        if (mounted) {
          if (getLeadNotes.fulfilled.match(result)) {
            setStatus('success')
          } else {
            setStatus('fail')
            toast.error('Error loading lead notes.')
          }
        }
      } catch {
        if (mounted) {
          setStatus('fail')
        }
      }
    }
    execute()

    return () => {
      mounted = false
    }
  }, [dispatch, leadId, take])

  return status
}
